import React from 'react';
import { Modal, Typography, Button } from 'antd';
import { FullscreenOutlined, FullscreenExitOutlined } from '@ant-design/icons';
import './FullscreenChart.css';

const { Title } = Typography;

interface FullscreenChartProps {
  chartId: string;
  title: string;
  isFullscreen: boolean;
  onToggleFullscreen: () => void;
  children: React.ReactNode;
  fullscreenContent: React.ReactNode;
  fullscreenTitle?: string;
}

const FullscreenChart: React.FC<FullscreenChartProps> = ({
  chartId,
  title,
  isFullscreen,
  onToggleFullscreen,
  children,
  fullscreenContent,
  fullscreenTitle
}) => {
  return (
    <div style={{ position: 'relative', height: '100%' }}>
      {/* Fullscreen Button */}
      <Button
        type="text"
        icon={isFullscreen ? <FullscreenExitOutlined /> : <FullscreenOutlined />}
        onClick={onToggleFullscreen}
                 style={{
           position: 'absolute',
           top: '-80px',
           right: '0',
           zIndex: 10,
           background: 'transparent',
           border: 'none',
           padding: '12px',
           minWidth: 'auto',
           height: 'auto',
           color: '#8c8c8c',
           fontSize: '24px'
         }}
         className="fullscreen-button"
        title={isFullscreen ? 'Exit Fullscreen' : 'Enter Fullscreen'}
      />
      
      {/* Chart Content */}
      {children}

      {/* Fullscreen Modal */}
             <Modal
         open={isFullscreen}
         onCancel={onToggleFullscreen}
         footer={null}
         width="95vw"
         style={{ top: 10 }}
         bodyStyle={{ 
           padding: '24px', 
           height: '90vh', 
           overflow: 'visible',
           display: 'flex',
           flexDirection: 'column'
         }}
         closeIcon={<div style={{ fontSize: '24px', width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>✕</div>}
       >
         <div style={{ 
           position: 'relative',
           marginBottom: '12px',
           minHeight: '40px',
           flexShrink: 0
         }}>
           {/* Overlay logo (doesn't affect layout height) */}
           <img 
             src="/sns-focus-logo.png" 
             alt="SNS Intelligence" 
             style={{ 
               position: 'absolute',
               left: '-38px',
               top: '-45px',
               height: '128px',
               width: 'auto',
               objectFit: 'contain'
             }} 
           />
           
           {/* Centered title */}
           <Title level={3} style={{ margin: 0, textAlign: 'center', lineHeight: '40px' }}>
             {fullscreenTitle || title }
           </Title>
         </div>
         <div style={{ 
           flex: '1 1 auto',
           minHeight: 0,
           position: 'relative'
         }}>
           {fullscreenContent}
         </div>
       </Modal>
    </div>
  );
};

export default FullscreenChart;
